export default "__VITE_PUBLIC_ASSET__fb6eedc3__"